
const GradientDefs = () => (
    <svg width="0" height="0">
        <linearGradient id="buttonGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="7.87%" stopColor="#EC221F" />
            <stop offset="88.1%" stopColor="#861311" />
        </linearGradient>
    </svg>
);

export default GradientDefs;